import { render } from "./link.md?vue&type=template&id=22285cee"
import script from "./link.md?vue&type=script&lang=js"
export * from "./link.md?vue&type=script&lang=js"
script.render = render

export default script